import React from 'react';
import styled, { css } from 'styled-components';
import { device } from '@/styles/template';

interface Props {
    children?: React.ReactNode;
    col: string;
    gap: string;
    gapDesktop?: string;
    margin?: string;
    colDesktop?: string;
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    centeredContent?: boolean;
    centeredContentMobileOnly?: boolean;
    centeredText?: boolean;
    autoWidth?: boolean;
    dangerouslySetInnerHTML?: { __html: string };
    centeredVertical?: boolean;
}

const GRID_PROPS = new Set(['centeredContent','centeredContentMobileOnly','centeredText','centeredVertical','autoWidth','gapDesktop','colDesktop']);

const Wrap = styled.div.withConfig({
    shouldForwardProp: (prop) => !GRID_PROPS.has(prop),
})<Props>`
    display: grid;
    //align-items: start;
    width: 100%;
    grid-template-columns: repeat(${({ col }) => col ?? 1}, minmax(0, 1fr));
    grid-template-rows: auto;
    gap: ${({ gap }) => gap ?? 0}rem;
    //place-items: center;
    padding: ${({ margin }) => margin ?? 0}rem 0;
    
    ${({ centeredContent }) => centeredContent && css`
        justify-items: center;
    `}

    ${({ centeredVertical }) => centeredVertical && css`
        align-items: center;
    `}


    ${({ centeredContentMobileOnly }) => centeredContentMobileOnly && css`
        justify-items: center;

        @media ${device.tablet} {
            justify-items: normal;
        }
    `}

    ${({ centeredText }) => centeredText && css`
        text-align: center;
    `} 
    
    ${({ autoWidth }) => autoWidth && css`
      grid-template-columns: auto auto;
    `}
    
    @media ${device.tablet} { 
      grid-template-columns: repeat(${({ colDesktop, col }) => colDesktop ?? col ?? 1}, minmax(0, 1fr));
      gap: ${({ gapDesktop, gap }) => gapDesktop ?? gap ?? 0}rem;
    }
`;

const Grid: React.FC<Props> = props => {
    const { children, ...restProps } = props;
    return <Wrap {...restProps}>{children}</Wrap>
}

export default Grid